import { Tag } from "ui-kit/icon";
import { IIngestionSourceData } from './types';

const imagineRetail: IIngestionSourceData = {
  isEcom: false,
  isAutomated: false,
  displayName: "Imagine Retail",
  listInventory: {
    linkHref: "/listInventory/imagine",
    icon: Tag
  }
};

export default imagineRetail;
